import { NgModule } from '@angular/core'

import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'

import { OrderHistoryRoutingModule } from './orderhistory-routing.module'
import { SharedModule } from '../shared/shared.module'

import { OrderHistoryService } from './services/orderhistory.service'

import { reducers } from './reducers'
import { OrderHistoryEffects } from './effects/order-history.effects'

import { OrderhistoryPageContainerComponent } from './containers/orderhistory-page-container/orderhistory-page-container.component'
import { OrderhistorylinesPageContainerComponent } from './containers/orderhistorylines-page-container/orderhistorylines-page-container.component'

import { OrderhistoryPageComponent } from './components/orderhistory-page/orderhistory-page.component'
import { OrderhistorylinesPageComponent } from './components/orderhistorylines-page/orderhistorylines-page.component';
import { OrderhistorylinesLineComponent } from './components/orderhistorylines-line/orderhistorylines-line.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  providers: [
    OrderHistoryService
  ],
  declarations: [
    OrderhistoryPageContainerComponent,
    OrderhistorylinesPageContainerComponent,
    OrderhistoryPageComponent,
    OrderhistorylinesPageComponent,
    OrderhistorylinesLineComponent
  ]
})
export class OrderHistoryModule {
  public static forRoot() {
    return {
      ngModule: RootOrderHistoryModule
    }
  }
 }

@NgModule({
  imports: [
    OrderHistoryModule,
    OrderHistoryRoutingModule,
    StoreModule.forFeature('orderhistory', reducers),
    EffectsModule.forFeature([
      OrderHistoryEffects
    ])
  ]
})
export class RootOrderHistoryModule { }
